(() => {
  function initialize(section) {
    if (section.dataset.railReady) return;
    section.dataset.railReady = 'true';
    const rail = section.querySelector('.featured-categories');
    const cards = [...rail.querySelectorAll('[data-featured-category]')];
    const previous = section.querySelector('[data-rail-previous]');
    const next = section.querySelector('[data-rail-next]');
    let last = {};
    try { last = JSON.parse(sessionStorage.getItem('bdtf-featured-categories') || '{}'); } catch {}
    const month=new Date().getMonth()+1;
    const seasonal=month<=2?['valentine-s-day','st.-patrick-s-day']:month<=4?['easter','spring']:month<=7?['summer','patriotic']:month<=9?['teacher-school','fall-thanksgiving']:month===10?['halloween','fall-thanksgiving']:['christmas-winter','winter'];
    const order=[...seasonal,'mama','coffee-lovers','teacher-school','western','trendy','christmas-winter'];
    const rank=slug=>{const i=order.indexOf(slug);return i<0?order.length:i;};
    cards.sort((a,b)=>rank(a.dataset.featuredCategory)-rank(b.dataset.featuredCategory));
    // Replace once so scroll anchoring cannot follow a moved card into the middle.
    rail.replaceChildren(...cards);
    rail.scrollLeft = 0;
    // All links and first covers are server rendered. Extra choices are small,
    // cacheable and requested only when this section approaches the viewport.
    let coversStarted = false;
    const loadCovers = async () => {
      if (coversStarted) return;
      coversStarted = true;
      try {
        const url = JSON.parse(section.querySelector('[data-featured-pool-url]').textContent);
        const response = await fetch(url);
        if (!response.ok) throw new Error('Cover choices unavailable');
        const pool = await response.json(), selected = {};
        if (!section.isConnected) return;
        for (const card of cards) {
          const slug = card.dataset.featuredCategory, previews = pool[slug] || [];
          const alternatives = previews.filter(item => item.url !== last.previews?.[slug]);
          const choices = alternatives.length ? alternatives : previews;
          const image = card.querySelector('img');
          if (choices.length) image.src = choices[Math.floor(Math.random() * choices.length)].url;
          selected[slug] = image.src;
        }
        sessionStorage.setItem('bdtf-featured-categories', JSON.stringify({
          first: cards.slice(0, 16).map(card => card.dataset.featuredCategory), previews: selected
        }));
      } catch { /* The complete SSR category navigation remains usable. */ }
    };
    const coverObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { coverObserver.disconnect(); loadCovers(); }
    }, {rootMargin:'300px'}) : null;
    if (coverObserver) coverObserver.observe(section); else loadCovers();
    const update = () => {
      previous.disabled = rail.scrollLeft <= 1;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      section.querySelector('.rail-controls').hidden = rail.scrollWidth <= rail.clientWidth + 2;
    };
    const move = direction => {
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      const step = (cards[0]?.getBoundingClientRect().width || 240) + gap;
      const count = Math.max(1, Math.floor((rail.clientWidth + gap) / step));
      const target = Math.round(rail.scrollLeft / step) * step + direction * count * step;
      rail.scrollTo({ left: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', update, { passive: true });
    rail.addEventListener('focusin', event => {
      const card = event.target.closest('[data-featured-category]');
      if (card) card.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
    });
    const observer = new ResizeObserver(update);
    observer.observe(rail);
    update();
    // Theme editor sections can be unloaded independently of the page.
    section.addEventListener('shopify:section:unload', () => { observer.disconnect(); coverObserver?.disconnect(); }, { once: true });
  }
  document.querySelectorAll('[data-category-rail]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-category-rail]').forEach(initialize));
})();
